import React, { useContext, useMemo, useState as classicUseState } from 'react';
import { CSSTransition } from 'react-transition-group';
import { ClickAwayListener } from '@material-ui/core';
import { useNavigationState } from '@store/hookstate';
import { Icon as BlueIcon } from '@blueprintjs/core';

import { IManufacturerCreateUpdate } from '@models/Manufacturer.model';
import { IProductCreateUpdate } from '@models/Product.model';
import { MenuContent } from './components';

import {
  Container,
  Block,
  ContainerSidebar,
  MenuText,
  IconContainer,
} from './Menu.styles';
import { CreateUpdateContext } from '../../../CreateUpdatesDialog.query';

interface IMenu {
  manufacturers: IManufacturerCreateUpdate[];
  products: IProductCreateUpdate[];
}

const Menu = ({ manufacturers, products }: IMenu) => {
  const { relatesTo } = useContext(CreateUpdateContext);

  const [open, setOpen] = classicUseState(false);
  const navigationState = useNavigationState();
  const handleClickAway = () => {
    setOpen(false);
  };

  const amount = useMemo(() => {
    if (relatesTo.get() === 'manufacturers') return manufacturers.length;
    if (relatesTo.get() === 'products') return products.length;
    return 0;
  }, [relatesTo.get(), manufacturers, products]);

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Container>
        <ContainerSidebar onClick={() => setOpen(!open)}>
          <MenuText>{amount} Selected Items</MenuText>
          <IconContainer>
            {open ? (
              <BlueIcon icon="chevron-up" color="#1371fe" />
            ) : (
              <BlueIcon icon="chevron-down" color="#1371fe" />
            )}
          </IconContainer>
        </ContainerSidebar>

        <CSSTransition
          in={open}
          timeout={300}
          classNames="my-node"
          unmountOnExit
          onEnter={() => setOpen(true)}
          onExited={() => setOpen(false)}
        >
          <Block
            width={
              navigationState.sidebarOpen.get()
                ? navigationState.maxLeft.get()
                : navigationState.minLeft.get()
            }
          >
            <MenuContent
              amount={amount}
              setOpenMenu={setOpen}
              products={products}
            />
          </Block>
        </CSSTransition>
      </Container>
    </ClickAwayListener>
  );
};

export { Menu };
